var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-select',_vm._g({attrs:{"items":_vm.items},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }